export const GALLERY_CONFIG = {
  // Google Drive API key (Browser key)
  apiKey: 'AIzaSyBb27-sZoB6pBDiPp-rPAzV2KRU_qoZY-M',
  // Folder ID of your Google Drive "Gallery" directory
  folderId: '1x5HUqDQo_UBNXwx4m1Ugfw_pGax4tOd1',
  splash_screen: '1vjfelC0ZjXqIwJBUGh93vhQRmMzTPXLV'
};

